<template>
  <el-row
    style="height: 80px;"
    :gutter="$gutter"
    type="flex"
    justify="end"
    align="middle"
  >
    <el-col>
      <router-link to="/">
        <img
          class="logo"
          alt="Owiwi"
          title="Owiwi"
          src="~assets/icons/logo.png"
          srcset="~assets/icons/logo@2x.png 2x, ~assets/icons/logo@3x.png 3x"
        >
      </router-link>
    </el-col>
  </el-row>
</template>

<script>

export default {
  name: 'GuestHeader'
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .register-steps {
    max-width: 410px;
    margin: 0 auto;
  }

  .back-link {
    letter-spacing: 0.1px;
    font-weight: 600;
    font-size: $-font-size-s;

    .fa-angle-left {
      font-size: 26px;
      padding-right: 10px;
    }
  }
</style>
